import React from "react";
import Button from "react-bulma-components/lib/components/button";
import { inject, observer } from "mobx-react";
import { Redirect } from "react-router-dom";
import { toast } from 'react-toastify';
import { createBrowserHistory as createHistory } from 'history'
import Loader from 'react-loader-spinner'
const history = createHistory()

@inject('artistDetails', 'followAndLikeStore')
@observer
export default class FollowersList extends React.Component {
    constructor(props) {
        super(props);
        let followMap = this.initializeFreshState(props);

        this.state = followMap;
        // console.log("[follow] This state will look like", { followMap });
    }


    initializeFreshState(props) {
        props = props || this.props;
        console.log(props.artistFollowersList);
        let followMap = {};
        (props.following) ?
            (props.artistFollowersList) ?
                props.artistFollowersList.forEach(
                    (el, elIndex) => {
                        // console.log( followMap[el.name] = el.currentArtistFollows)

                        // followMap[el.name] = {}
                        // props.artistFollowersList.forEach(choice => {
                        followMap[el.user_profile.id] = el.user_profile.isfollowing;
                        // })

                    }
                )

                : {}


            :
            (props.artistFollowersList) ?
                props.artistFollowersList.forEach(
                    (el, elIndex) => {
                        // console.log( followMap[el.name] = el.currentArtistFollows)

                        // followMap[el.name] = {}
                        // props.artistFollowersList.forEach(choice => {
                        followMap[el.follower_profile.id] = el.follower_profile.isfollowing;
                        // })

                    }
                ) : {}
        return followMap;
    }
    handleArtistClick(id) {
        this.setState({
            clickedOn: id,
            navToUserProfile: true
        }, () => {
            this.props.close()
        })
    }
    handleFollowUnfollow(id) {
        // console.log(id);
        // console.log(this.state[id])
        this.setState({
            [id]: !this.state[id]
        }, function () {
            // console.log(this.state);
            (this.state[id]) ?

                this.props.followAndLikeStore.followTheArtist(id)
                    .then((res) => {
                        toast("You are now following this user!");
                        ((this.props.following) ? this.props.followAndLikeStore.followingList(this.props.id)
                            : this.props.followAndLikeStore.followersList(this.props.id)
                        )
                            .then((res) => {

                                // console.log(res);
                                this.setState({

                                    userList: res.data.data
                                })
                            })
                    }) :
                this.props.followAndLikeStore.unFollowTheArtist(id)
                    .then((resp) => {
                        toast("You have unfollowed this user");
                        ((this.props.following) ? this.props.followAndLikeStore.followingList(this.props.id)
                            : this.props.followAndLikeStore.followersList(this.props.id)
                        )
                            .then((res) => {
                                // console.log(res);
                                this.setState({

                                    userList: res.data.data
                                })
                            })
                    })
        })

    }
    render() {
        // if (this.state.navToUserProfile) {
        //     return (
        //         <Redirect push to={this.state.clickedOn}/>
        //     )
        // }
        // let { artistFollowersList } = props
        // console.log("[this.props.followlist]", this.props.artistFollowersList);



        return (
            (!this.props.following) ?

                (this.props.artistFollowersList && this.props.artistFollowersList.length) ?
                    ((this.state.userList) ? this.state.userList : this.props.artistFollowersList).map(

                        (el, elIndex) => (
                            <div style={{ height: "auto" }}>
                                <div key={elIndex} className="followers-list-section">

                                    <div className="followers-list-elements">
                                        <a href={`/profile/details/${el.follower_profile.share_url.substr(el.follower_profile.share_url.lastIndexOf("/") + 1)}`}>
                                            <img style={{ cursor: "pointer" }}
                                                // onClick={() => this.handleArtistClick(el.follower_profile.share_url)}
                                                src={(!!el.follower_profile.image) ? el.follower_profile.image : (!!el.follower_profile.fb_id) ? `http://graph.facebook.com/${el.follower_profile.fb_id}/picture?type=large` : require('../../assets/default_square_picture.png')} className="follower-profile-picture" alt="" ></img>
                                        </a>
                                        <a href={`/profile/details/${el.follower_profile.share_url.substr(el.follower_profile.share_url.lastIndexOf("/") + 1)}`}>                                        <div style={{ cursor: "pointer" }}
                                            // onClick={() => this.handleArtistClick(el.follower_profile.share_url)} 
                                            className="followers-list-artist-info">
                                            <p className="followers-list-artist-name" style={{ minHeight: "1em" }}>
                                                {el.follower_profile.full_name}

                                            </p>
                                            <p className="followers-list-artist-location">
                                                {el.follower_profile.country}
                                            </p>
                                        </div>
                                        </a>
                                    </div>
                                    <div className="btn-followers">
                                        <div className="pull-right mr-25">
                                            <Button
                                                style={{
                                                    display: (el.follower_profile.id == localStorage.getItem("profile_id") ? "none" : "")
                                                }}
                                                onClick={() => this.handleFollowUnfollow(el.follower_profile.id)}
                                                className={(this.state[el.follower_profile.id]) ? "masterpieces-tertiary-black-button" : "masterpieces-primary-buttons"}>
                                                <p className={(this.state[el.follower_profile.id]) ? "unfollow-text" : "follow-text"}>
                                                    {(this.state[el.follower_profile.id]) ? "Unfollow" : "Follow"}</p></Button>
                                        </div>
                                    </div>


                                </div>
                                <hr className="horizontal-rule-followers-list"></hr>
                            </div>

                        )
                    )
                    : <div style={{ height: "auto" }}>
                        <div className="followers-list-section">
                            <div className="followers-list-elements ml-25 mb-15 mt-15">
                                <p className="followers-list-artist-name" style={{ minHeight: "1em" }}>
                                    {
                                        (this.props.loading) ?
                                            /*<Loader
                                            type="watch"
                                            color="#00BFFF"
                                            height="100"
                                            width="100"
                                         />  */
                                            "Please wait..."
                                            :
                                            "No Followers"}
                                </p>
                            </div>
                        </div>
                    </div>


                :
                (this.props.artistFollowersList && this.props.artistFollowersList.length) ?
                    ((this.state.userList) ? this.state.userList : this.props.artistFollowersList).map(

                        (el, elIndex) => (
                            <div style={{ height: "auto" }}>
                                <div key={elIndex} className="followers-list-section">
                                    <div className="followers-list-elements">
                                        <a href={`/profile/details/${el.user_profile.share_url.substr(el.user_profile.share_url.lastIndexOf("/") + 1)}`}><img style={{ cursor: "pointer" }}

                                            src={el.user_profile.image || (el.user_profile.fb_id && `https://graph.facebook.com/${el.user_profile.fb_id}/picture?type=large`) || require('../../assets/default_square_picture.png')} className="follower-profile-picture" alt="" ></img></a>
                                        <a href={`/profile/details/${el.user_profile.share_url.substr(el.user_profile.share_url.lastIndexOf("/") + 1)}`}>
                                            <div className="followers-list-artist-info"
                                                style={{ cursor: "pointer" }}>
                                                <p className="followers-list-artist-name" style={{ minHeight: "1em" }}>
                                                    {el.user_profile.full_name}
                                                </p>
                                                <p className="followers-list-artist-location">
                                                    {el.user_profile.country}
                                                </p>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="btn-followers">
                                        <div className="pull-right mr-25">
                                            <Button
                                                style={{
                                                    display: (el.user_profile.id == localStorage.getItem("profile_id") ? "none" : "")
                                                }}
                                                onClick={() => this.handleFollowUnfollow(el.user_profile.id)} className={(this.state[el.user_profile.id]) ? "masterpieces-tertiary-black-button" : "masterpieces-primary-buttons"}><p className={(this.state[el.user_profile.id]) ? "unfollow-text" : "follow-text"}>{(this.state[el.user_profile.id]) ? "Unfollow" : "Follow"}</p></Button>
                                        </div>
                                    </div>

                                    {/* <Loader
                                   type="Watch"
                                   color="#00BFFF"
                                   height="100"
                                   width="100"
                                />  */}
                                </div>
                                <hr className="horizontal-rule-followers-list"></hr>
                            </div>

                        )
                    )
                    : <div style={{ height: "auto" }}>
                        <div className="followers-list-section">
                            <div className="followers-list-elements ml-25 mb-15 mt-15">
                                <p className="followers-list-artist-name" style={{ minHeight: "1em" }}>
                                    {(this.props.loading) ?
                                        /*    <Loader
                                           type="Watch"
                                           color="gray"
                                           height="35"
                                           width="35"
                                        />  */
                                        "Please wait..."
                                        : "Not following any user"}
                                </p>
                            </div>
                        </div>
                    </div>


        )
    }
}



// WEBPACK FOOTER //
// ./src/components/artist/followersList.js